import React, { useCallback, useState } from 'react';
import Checkbox from '../../Checkbox';
import s from './ModalDoNotShowAgain.scss';
/** Control for the do not show again feature of confirm modals */ const ModalDoNotShowAgain = ({ onDoNotShowAgainChange, doNotShowAgainText })=>{
    const [checked, setChecked] = useState(false);
    const onChange = useCallback((value)=>{
        setChecked(value);
        onDoNotShowAgainChange(value);
    }, [
        onDoNotShowAgainChange
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        onChange: onChange,
        isChecked: checked,
        labelClassName: s['label']
    }, doNotShowAgainText));
};
ModalDoNotShowAgain.displayName = 'ModalDoNotShowAgain';
export default ModalDoNotShowAgain;
